import { render } from "./ArchivalView.vue?vue&type=template&id=9fbe7334&scoped=true"
import script from "./ArchivalView.vue?vue&type=script&lang=js"
export * from "./ArchivalView.vue?vue&type=script&lang=js"

import "./ArchivalView.vue?vue&type=style&index=0&id=9fbe7334&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fbe7334"]])

export default __exports__